/** Provisional wire value for app WebView article `page_type`. */
export const MOBILE_APP_ARTICLE_PAGE_TYPE = "article";

export type MobileAppArticleDfpVariables = {
  page_type: string[];
  in_app?: boolean;
};

/**
 * SB Nation app WebView: mark interior article pages as app traffic so GAM can
 * target them and Concert can tag Permutive as iOS. Scoped to app requests only;
 * desktop/web keeps page_type = interior_page and no in_app (omit when false).
 */
export function applyMobileAppArticleDfpVariables(
  dfpVariables: MobileAppArticleDfpVariables,
  {
    isMobileAppRequest,
    pageType,
  }: {
    isMobileAppRequest?: boolean;
    pageType: string;
  },
): void {
  if (isMobileAppRequest && pageType === "interior_page") {
    dfpVariables.page_type = [MOBILE_APP_ARTICLE_PAGE_TYPE];
    dfpVariables.in_app = true;
  }
}
